import { useEffect, useState, useMemo, useCallback } from 'react';
import { useApi } from '../services/api';
import { useAuth } from '@frontegg/react';
import { AppError, SamlResponse, UseSamlResponseProps } from '../CustomTypes';

export const useSamlResponse = ({ props }: UseSamlResponseProps) => {
  const [samlResponse, setSamlResponse] = useState<string | null>(null);
  const [action, setAction] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<AppError | null>(null);
  const [requestMade, setRequestMade] = useState<boolean>(false);
  const { isAuthenticated } = useAuth();
 
  const queryString = useMemo(() => {
    const params = new URLSearchParams();
    if (props.tenantId) {
      params.append('tenantId', props.tenantId);
    }
    if (props.settingsId) {
      params.append('settingsId', props.settingsId);
    }
    if (props.impersonate) {
      params.append('impersonate', props.impersonate);
    }
    return params.toString();
  }, [props.tenantId, props.settingsId, props.impersonate]);

  const fetchFromApi = useApi<SamlResponse>(`GenerateSamlResponse?${queryString}`, "GET");

  const fetchData = useCallback(async () => {
    if (!isAuthenticated || !props.tenantId || !props.settingsId || requestMade) {
      return;
    }

    setLoading(true);
    setError(null);
    setRequestMade(true);

    try {
      const response = await fetchFromApi();
      if (response.error) {
        setError(response.error);
      } else if (response.data) {
        setSamlResponse(response.data.results);
        setAction(response.data.action);
      }
    } catch (err) {
      setError({ message: (err as Error).message });
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, props.tenantId, props.settingsId, requestMade, fetchFromApi]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { samlResponse, action, loading, error };
};

export {};